(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("LoadingScreen", [], factory);
	else if(typeof exports === 'object')
		exports["LoadingScreen"] = factory();
	else
		root["LoadingScreen"] = factory();
})(this, function() {
return 